
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchWorkerReports, fetchWorkerReportStatistics } from './actions';
import { ReportsState, WorkerReportResponse, WorkerReportStatistics } from './types';

const initialState: ReportsState = {
  workerReports: {
    data: [],
    count: 0,
    loading: false,
    error: null,
  },
  workerReportStatistics: {
    data: {
      total_workers: 0,
      overtime_workers: 0,
    },
    loading: false,
    error: null,
  },
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkerReports.pending, (state) => {
        state.workerReports.loading = true;
        state.workerReports.error = null;
      })
      .addCase(fetchWorkerReports.fulfilled, (state, action: PayloadAction<WorkerReportResponse>) => {
        state.workerReports.loading = false;
        state.workerReports.data = action.payload.results;
        state.workerReports.count = action.payload.count;
      })
      .addCase(fetchWorkerReports.rejected, (state, action) => {
        state.workerReports.loading = false;
        state.workerReports.error = action.payload as string;
      })
      .addCase(fetchWorkerReportStatistics.pending, (state) => {
        state.workerReportStatistics.loading = true;
        state.workerReportStatistics.error = null;
      })
      .addCase(fetchWorkerReportStatistics.fulfilled, (state, action: PayloadAction<WorkerReportStatistics>) => {
        state.workerReportStatistics.loading = false;
        state.workerReportStatistics.data = action.payload;
      })
      .addCase(fetchWorkerReportStatistics.rejected, (state, action) => {
        state.workerReportStatistics.loading = false;
        state.workerReportStatistics.error = action.payload as string;
      });
  },
});

export const reportsReducer = reportsSlice.reducer;
